import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  notAllow: {
    cursor: 'not-allowed',
  },
}));

export default useStyles;
